interface CanvasKeyEvent {
  readonly key: string;
  readonly shiftKey: boolean;
  readonly preventDefault: () => void;
}

interface CanvasKeyOptions {
  readonly selectedNodeId: string | null;
  /** 선택한 노드에 상자가 있는지(그룹이 아닌지) — 화살표 이동은 상자가 있을 때만. */
  readonly hasBox: boolean;
  readonly onSelect: (nodeId: string | null) => void;
  readonly onDeleteSelected: () => void;
  readonly onNudge: (dxMm: number, dyMm: number) => void;
}

/**
 * 편집 캔버스 키보드 — Esc(선택 해제), Delete/Backspace(삭제), 화살표 1mm(Shift 10mm). 평면·휜 편집 캔버스가 같이 쓴다.
 * 그룹은 상자가 없어 옮길 수 없지만 삭제는 된다(스펙 §2-3).
 */
export const handleCanvasKeyDown = (event: CanvasKeyEvent, options: CanvasKeyOptions): void => {
  const { selectedNodeId, hasBox, onSelect, onDeleteSelected, onNudge } = options;
  if (event.key === 'Escape' && selectedNodeId !== null) {
    event.preventDefault();
    onSelect(null);
    return;
  }
  if (selectedNodeId !== null && (event.key === 'Delete' || event.key === 'Backspace')) {
    event.preventDefault();
    onDeleteSelected();
    return;
  }
  if (!hasBox) return;
  const step = event.shiftKey ? 10 : 1;
  const moves: Record<string, [number, number]> = {
    ArrowLeft: [-step, 0],
    ArrowRight: [step, 0],
    ArrowUp: [0, -step],
    ArrowDown: [0, step],
  };
  const move = moves[event.key];
  if (move !== undefined) {
    event.preventDefault();
    onNudge(move[0], move[1]);
  }
};
